import React, { useContext, useEffect, useState } from 'react'
import { PageContext } from "../App";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { TextAtom } from "../atoms/TextAtom";
import {GoBackButton, StandardButton } from "../atoms/buttons";
import { TitleAtom } from "../atoms/titleAtom";
import { getAPI } from "../api/api";
import { Spinner } from "../atoms/spinner";
import { ReusableTable } from "../components/ReusableTableComp";
import { STATUS } from "../constants/statusLabels";
import { AddLeadToTask } from "../components/taskModal";
import { icon } from "../functions/icons";

export function TasksInfo({pageSwap}) {
    const navigationContext = useContext(PageContext);
    const task = navigationContext.sidebar.task
    
    const handleGoBack = () => {
        navigationContext.handleNavigation({navigation: 17})
    }
   

    return (
        <VerticalPageLayout className={`standard-padding page-in-animation ${pageSwap && "page-out-animation"}`} style={{ width: "auto", gap: "1.5rem" }}>
            <HorizontalLayout style={{ gap: "1rem" }}>
                <GoBackButton className={"no-margin"} left={true} onClick={handleGoBack} />
                <VerticalLayout>
                    <TitleAtom title={task?.title || ""} />
                    <TextAtom className={"standard-text-color-light small-text"} title={task?.description || ""} />
                </VerticalLayout>
            </HorizontalLayout>
            <TaskInfoTable id_task={task?.id_task} />
        </VerticalPageLayout>
    )
}
const TaskInfoTable = ({id_task}) => {
    const [loading, setLoading] = useState(false);
    const [taskModalActive, setTaskModalActive] = useState(false);
    const [leads, setLeads] = useState([]);
     const loadTaskLeads = async () => {
        setLoading(true);
        const query = `api/tasks/${id_task}/leads`
        const res = await getAPI(query);
        console.log("task leads", res);
        if (res.status === "ok"){
            setLeads(res.data);
        }
        setLoading(false);
    }
    useEffect(() => {
        loadTaskLeads()
    },[])
    const navigationContext = useContext(PageContext);
    const columns = [
        { key: "name", label: "Naam" },
        { key: "contact", label: "Contact" },
        { key: "status", label: "Status" },
        { key: "lastActivity", label: "Laatste activiteit" },
        { key: "action", label: "Actie" }
    ];
   
    const filters = [...[0, 1, 2, 3].map(statusId => ({ id: statusId, label: STATUS[statusId] || "not-found"}))];
     const rows = leads.map(lead => ({
        ...lead,
        name: `${lead.first_name} ${lead.last_name}`,
        status: lead.status,
        lastActivity: lead.last_activity ? new Date(lead.last_activity).toLocaleDateString() : "Geen activiteit",
        contact: <>{lead.email} <br /> {lead.phone_nummer}</>,
        filterId: lead.status,
    }));
    const handleGoToLead = (lead) => {
        navigationContext.handleNavigation({ ...navigationContext.sidebar, back_page: 18, navigation: 19, id_lead: lead.id_lead, id_lead_company: null  });
    }
    if (loading){
        return <VerticalPageLayout className={"center"}><Spinner /></VerticalPageLayout>
    }
    return(
        <>
        <AddLeadToTask selectedLeads={leads} id_task={id_task} visible={taskModalActive} dismiss={() => setTaskModalActive(false)} load={loadTaskLeads}/>
      {rows.length > 0 ? <ReusableTable
            visible={rows.length > 0}
            title={<>Gekoppelde leads <span className="extra-count">({rows.length})</span></>}
            addLabel="Lead toevoegen"
            onAdd={() => setTaskModalActive(!taskModalActive)}
            filterOptions={filters}
            columns={columns}
            rows={rows}
            unitName="leads"
            itemsPerPage={6}
            itemClick={handleGoToLead}
        /> : <FallbackTable unitName="leads" onClick={() => setTaskModalActive(!taskModalActive)} /> }
        </>
     
    )
    
}

const FallbackTable = ({unitName, onClick}) => {
    return (
        <HorizontalLayout className="card-background-color full-table-container standard-padding space-between" style={{ width: "auto"}}>
            <TitleAtom className={"medium-text"} title={`Gekoppelde ${unitName}`} />
             <StandardButton style={{ gap: ".5rem" }} className={"no-margin-left"} onClick={onClick}>
                    {icon("plus", 20, "var(--white)")}
             </StandardButton>
        </HorizontalLayout>
    )
}



